import { envConfig } from '../constants';
import { fetchWithRetry } from '../utils/fetch-with-retry';

export class EmailService {
  /**
   * Send onboarding email to user (for web app signups)
   */
  static async sendOnboardingEmail(accessToken: string): Promise<void> {
    try {
      const response = await fetchWithRetry(
        `${envConfig.EXPRESS_BACKEND_URL}/api/email/onboard`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            source: 'web', // Specify that this is from the web app
          }),
        }
      );

      if (!response.ok) {
        console.error('[EmailService] Failed to send onboarding email:', response.status);
      }
    } catch (error) {
      console.error('[EmailService] Error sending onboarding email:', error);
      // Don't throw - we don't want to fail the signup flow if email fails
    }
  }
}